import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Box, Hidden } from '@mui/material';

import { useMytaverseEvent } from '../../../../providers';

import LoadingProgress from '@components/LoadingProgress';
import SearchField from '../../../SearchField';
import ParticipantList from './ParticipantList';

import { ParticipantsTabViewProps } from './interfaces';

import { useStyles } from './styles';

const ParticipantsTabView = ({
  inputValue,
  onInputChange,
  onInputClear,
  activeRooms,
  currentParticipantId,
}: ParticipantsTabViewProps) => {
  const classes = useStyles();
  const { setLeftMenuScrollHandler } = useMytaverseEvent();
  const [page, setPage] = useState(1);

  const participantsList = useMemo(
    () =>
      activeRooms.slice().map((r) => {
        if (r.roomId === 'offline') {
          return {
            ...r,
            activeParticipants: r.activeParticipants.slice(0, 20 * page),
          };
        }

        return r;
      }),
    [activeRooms, page],
  );

  const handler = useCallback(
    (page: number) => {
      const offlineParticipants = activeRooms
        .find((r) => r.roomId === 'offline')
        ?.activeParticipants.slice(0, 20 * page);
      setPage(page);
      const elementIndex = participantsList.findIndex(
        (r) => r.roomId === 'offline',
      );

      if (!offlineParticipants) {
        return;
      }
      participantsList[elementIndex].activeParticipants = offlineParticipants;
    },
    [activeRooms, participantsList],
  );

  useEffect(() => {
    setLeftMenuScrollHandler(() => handler);

    return () => {
      setLeftMenuScrollHandler(null);
    };
  }, [handler, setLeftMenuScrollHandler]);

  return (
    <Box sx={classes.root} component="div">
      <Box component="div">
        <Hidden mdDown>
          <SearchField
            onChange={onInputChange}
            onClear={onInputClear}
            value={inputValue}
            sx={classes.input}
          />
        </Hidden>
        <Box id="participantsList" component="div">
          {participantsList.map((room) => (
            <ParticipantList
              key={room.roomId}
              name={room.name}
              participants={room.activeParticipants}
              isCollapsible={room.roomId === 'offline'}
              currentParticipantId={currentParticipantId}
            />
          )) || <LoadingProgress />}
        </Box>
      </Box>
    </Box>
  );
};

export default ParticipantsTabView;
